import script from "./filmSideView.vue?vue&type=script&setup=true&lang=js"
export * from "./filmSideView.vue?vue&type=script&setup=true&lang=js"

import "./filmSideView.vue?vue&type=style&index=0&id=1999849d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1999849d"]])

export default __exports__